import classNames from 'classnames';
import type { FC, PropsWithChildren } from 'react';
import useMutation from 'hooks/react-query/useMutation';

import { TrashIconOutline } from 'utils/icons';
import type { ButtonComponentProps } from './Button';
import { Button } from './Button';
import { FreeLoader } from './Loader';

type OptionWithDeleteProps = PropsWithChildren<{
  onDelete: () => Promise<any>;
  deleteButtonProps?: ButtonComponentProps;
  tabIndex?: number;
}>;

const OptionWithDelete: FC<OptionWithDeleteProps> = ({
  children,
  onDelete,
  deleteButtonProps,
  tabIndex,
}) => {
  const deleteItemMutation = useMutation(() => onDelete());

  const isButtonDisabled =
    deleteItemMutation.isLoading || deleteButtonProps?.disabled;

  return (
    <div className="flex justify-between items-center" tabIndex={tabIndex}>
      {children}
      <Button
        {...deleteButtonProps}
        disabled={false}
        asDefault
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          if (isButtonDisabled) return;
          deleteItemMutation.mutate();
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.stopPropagation();
            e.preventDefault();
            if (isButtonDisabled) return;
            deleteItemMutation.mutate();
          }
        }}
        className={classNames(
          'bg-red-100 p-1 rounded-md hover:bg-red-200 focus:bg-red-200 group',
          deleteButtonProps?.className,
        )}
      >
        {deleteItemMutation.isLoading ? (
          <FreeLoader className="w-5 h-5 text-red-300 fill-red-500" />
        ) : (
          <TrashIconOutline className="w-5 h-5 text-red-400 group-hover:text-red-500 group-focus:text-red-500" />
        )}
      </Button>
    </div>
  );
};

export default OptionWithDelete;
